import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-page-up",
  "use": "icon-page-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-page-up\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.795 7.552-4.243 4.243.653.653 3.59-3.59 3.59 3.59.653-.653zm0-4L3.552 7.795l.653.653 3.59-3.59 3.59 3.59.653-.653z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol